<template>
  <a-modal
      :open="open"
      title="微信扫码登录"
      :footer="null"
      :width="360"
      centered
      @cancel="cancel()"
  >
    <!-- 微信公众号登录 -->
    <a-qrcode :value="loginQrVal" :status="loginQrStatus" @refresh="refreshQr()" />
  </a-modal>
</template>

<script>
import {defineComponent, onMounted, ref} from 'vue'
import {useRouter} from 'vue-router';
import {message} from 'ant-design-vue'
import request from '@/utils/request'
import { setAccessToken } from "@/storage/token";

export default defineComponent({
  name: 'PcWechatOfficialAccountLogin',
  props: {
    method: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const router = useRouter();
    const open = ref(false)
    const loginQrVal = ref('')
    const loginQrStatus = ref('')
    const ticketData = ref()

    let expiredInterval, checkInterval

    const woaLogin = async (method) => {
      // 微信公众号登录
      loginQrStatus.value = 'loading'
      // 获取二维码ticket
      const response = await request.get(`/auth/wechat_official_account/login_qr?id=${method.provider_id}`)
      if (response.code !== 'success') {
        message.error(response.msg || '微信登录初始化失败')
        loginQrStatus.value = 'expired'
        return
      }
      ticketData.value = response.data

      // 二维码图片
      loginQrVal.value = response.data.url
      loginQrStatus.value = 'active'

      // 有任务的话先停了
      checkInterval ? clearInterval(checkInterval) : null
      expiredInterval ? clearInterval(expiredInterval) : null

      expiredInterval = setInterval(async () => {
        loginQrStatus.value = 'expired'
      }, response.data.expire_seconds * 1000)

      // 开始轮询检查扫码状态
      checkInterval = setInterval(async () => {
        try {
          const res = await request.get('/auth/wechat_official_account/check_ticket', {
            params: { ticket: ticketData.value.ticket }
          })

          if (res.code === 'success') {
            // 扫码登录成功
            clearInterval(checkInterval)
            clearInterval(expiredInterval)
            // 保存token并跳转
            setAccessToken(res.data.token)
            message.success('微信登录成功', 1, () => {
              router.push('/')
            })
          } else {
            console.error(res.msg || '微信登录失败')
            // message.error(res.msg || '微信登录失败')
          }
        } catch (error) {
          console.error('检查扫码状态失败:', error)
        }
      }, 2000) // 每2秒检查一次
    }

    const refreshQr = () => {
      woaLogin(props.method)
    }

    const cancel = () => {
      clearInterval(expiredInterval)
      clearInterval(checkInterval)
      open.value = false
    }

    onMounted(() => {
      open.value = true
      woaLogin(props.method)
    })

    return {
      open,
      loginQrVal,
      loginQrStatus,
      refreshQr,
      cancel
    }
  }
})
</script>

<style scoped>
</style>
